import { LoadingModule } from '@/components/ui/Loading'
import { declareComponent } from '@/registry'

export const Schools = /*#__PURE__*/ declareComponent(
  'schools',
  'module-schools',
  () => import(/* webpackChunkName: 'module-schools' */ '@project/components/modules/Schools/Schools'),
  LoadingModule,
)

export const MapSchools = /*#__PURE__*/ declareComponent(
  'map-schools',
  'module-map-schools',
  () => import(/* webpackChunkName: 'module-map-schools' */ '@project/components/map/MapSchools'),
  LoadingModule,
)

export const ThroughLines = /*#__PURE__*/ declareComponent(
  'map-through-lines',
  'module-map-through-lines',
  () => import(/* webpackChunkName: 'module-map-through-lines' */ '@project/components/map/ThroughLines'),
  LoadingModule,
)
